<template>
  <Dialog />
  <b-snackbar></b-snackbar>
  <b-confirm></b-confirm>
  <RouterView />
</template>

<script>
import Dialog from '@/dialog/dialog.vue'
import { BConfirm, BSnackbar } from 'best-modules/components'

import { useBreadcrumb, useRoute } from '@/plugins'

import { onErrorCaptured, watch } from 'vue'

export default {
  components: { Dialog, BSnackbar, BConfirm },
  setup() {
    const route = useRoute()
    const breadcrumb = useBreadcrumb()

    onErrorCaptured(err => {
      console.info(err)
    })

    // set breadcrumb
    watch(
      () => route.matched.find(r => r.meta.tabList)?.name || route.name,
      () => {
        breadcrumb.setRoutes(route.matched, route.params)
      }
    )
    // set breadcrumb part
    watch(
      () => route.matched.find(r => r.meta.breadcrumbIdx),
      r => {
        if (r) {
          breadcrumb.set([{ title: r.meta.title, index: r.meta.breadcrumbIdx }])
        }
      }
    )
  },
}
</script>

<style scoped>
header {
  line-height: 1.5;
  max-height: 100vh;
}
</style>
